import api from './api';

// Module-level cache of company tax settings, shared across the app for a session. Lives in the
// service layer (not a page hook) so AuthContext can clear it without reaching into pages/.
// Cleared on login/logout so a stale company state code can't drive a wrong CGST/SGST vs IGST
// split for the next user in the same browser tab.
let _cache = null;

export function getTaxSettingsCache() {
  return _cache;
}

export function setTaxSettingsCache(value) {
  _cache = value;
}

export function clearCompanyTaxSettingsCache() {
  _cache = null;
}

/**
 * @typedef {Object} TaxSettings
 * @property {string} companyStateCode
 * @property {string} companyGstin
 * @property {string|number} defaultGstRate
 * @property {number} version
 * @property {string} updatedAt
 * @property {string} updatedBy
 * @property {boolean} gstinConfigured
 */

/**
 * Fetch current company tax settings.
 * @returns {Promise<TaxSettings>}
 */
export async function fetchTaxSettings() {
  const { data } = await api.get('/admin/tax-settings');
  return data.data;
}

/**
 * Update company tax settings.
 * @param {{companyStateCode: string, companyGstin: string, defaultGstRate: number|string, version: number}} payload
 * @returns {Promise<TaxSettings>}
 */
export async function updateTaxSettings(payload) {
  const { data } = await api.put('/admin/tax-settings', payload);
  return data.data;
}
